// Automatically generated
export const USE_PICKER_BASE_STATE_KEYS = [
  "baseId",
  "visible",
  "animated",
  "modal",
  "placement",
  "unstable_fixed",
  "unstable_flip",
  "unstable_offset",
  "gutter",
  "unstable_preventOverflow",
  "isDisabled",
  "isReadOnly",
  "pickerId",
  "dialogId",
  "segmentFocus",
] as const;
export const PICKER_BASE_STATE_KEYS = [
  "baseId",
  "unstable_idCountRef",
  "visible",
  "animated",
  "animating",
  "setBaseId",
  "show",
  "hide",
  "toggle",
  "setVisible",
  "setAnimated",
  "stopAnimation",
  "modal",
  "unstable_disclosureRef",
  "setModal",
  "unstable_referenceRef",
  "unstable_popoverRef",
  "unstable_arrowRef",
  "unstable_popoverStyles",
  "unstable_arrowStyles",
  "unstable_originalPlacement",
  "unstable_update",
  "placement",
  "place",
  "pickerId",
  "dialogId",
  "isDisabled",
  "isReadOnly",
  "segmentFocus",
] as const;
export const PICKER_BASE_KEYS = PICKER_BASE_STATE_KEYS;
export const PICKER_BASE_CONTENT_KEYS = PICKER_BASE_KEYS;
export const PICKER_BASE_TRIGGER_KEYS = PICKER_BASE_CONTENT_KEYS;
